import React from "react";
import { Link } from "react-router-dom"; // assuming you're using react-router-dom for navigation

export default function PageNotFound() {
  return (
    <div className="m-5 -mt-3">
      <div className="h-[87vh] p-5 rounded-lg bg-gray-100 shadow-lg flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-red-500 animate-pulse mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-2">Page Not Found</h2>
          <p className="text-lg text-gray-500 mb-6">Oops! The page you're looking for doesn't exist.</p>
          <img
            src="https://cdn.vectorstock.com/i/1000v/42/66/sad-emoji-character-vector-11514266.jpg" 
            alt="Sad emoji"
            className="w-32 h-32 mx-auto mb-4"
          />
          <Link to="/" className="bg-primary text-white px-6 py-2 rounded-full hover:bg-blue-700 transition duration-300">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
